import { render, staticRenderFns } from "./CaseSubmissionForm.vue?vue&type=template&id=713ecee9&scoped=true&"
import script from "./CaseSubmissionForm.vue?vue&type=script&lang=js&"
export * from "./CaseSubmissionForm.vue?vue&type=script&lang=js&"
import style0 from "./CaseSubmissionForm.vue?vue&type=style&index=0&id=713ecee9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713ecee9",
  null
  
)

export default component.exports